import {TableCell, TableRow} from '@/components/ui/table'

interface TableEmptyStateProps {
    colSpan: number
    hasFilters: boolean
    matchMessage: string
    emptyMessage: string
}

export function TableEmptyState({colSpan, hasFilters, matchMessage, emptyMessage}: TableEmptyStateProps) {
    return (
        <TableRow>
            <TableCell
                data-testid="table-empty-state"
                colSpan={colSpan}
                className="text-center text-muted-foreground py-8"
            >
                {hasFilters ? matchMessage : emptyMessage}
            </TableCell>
        </TableRow>
    )
}
